/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Source_Frame_Rate_LabelInputs */

const en_subtitle_import_source_frame_rate_label = /** @type {(inputs: Subtitle_Import_Source_Frame_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source Framerate`)
};

const fr_subtitle_import_source_frame_rate_label = /** @type {(inputs: Subtitle_Import_Source_Frame_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequence d'images source`)
};

const de_subtitle_import_source_frame_rate_label = /** @type {(inputs: Subtitle_Import_Source_Frame_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quellbildrate`)
};

const it_subtitle_import_source_frame_rate_label = /** @type {(inputs: Subtitle_Import_Source_Frame_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequenza fotogrammi sorgente`)
};

const ru_subtitle_import_source_frame_rate_label = /** @type {(inputs: Subtitle_Import_Source_Frame_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Исходная частота кадров`)
};

const es_subtitle_import_source_frame_rate_label = /** @type {(inputs: Subtitle_Import_Source_Frame_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad de cuadros de origen`)
};

const zh_cn2_subtitle_import_source_frame_rate_label = /** @type {(inputs: Subtitle_Import_Source_Frame_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`源帧率`)
};

const ja_subtitle_import_source_frame_rate_label = /** @type {(inputs: Subtitle_Import_Source_Frame_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソースフレームレート`)
};

const hi_subtitle_import_source_frame_rate_label = /** @type {(inputs: Subtitle_Import_Source_Frame_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्रोत फ्रेमरेट`)
};

const pt_pt2_subtitle_import_source_frame_rate_label = /** @type {(inputs: Subtitle_Import_Source_Frame_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxa de quadros da fonte`)
};

/**
* | output |
* | --- |
* | "Source Framerate" |
*
* @param {Subtitle_Import_Source_Frame_Rate_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_source_frame_rate_label = /** @type {((inputs?: Subtitle_Import_Source_Frame_Rate_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Source_Frame_Rate_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_import_source_frame_rate_label(inputs)
	if (locale === "de") return de_subtitle_import_source_frame_rate_label(inputs)
	if (locale === "it") return it_subtitle_import_source_frame_rate_label(inputs)
	if (locale === "ru") return ru_subtitle_import_source_frame_rate_label(inputs)
	if (locale === "es") return es_subtitle_import_source_frame_rate_label(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_import_source_frame_rate_label(inputs)
	if (locale === "ja") return ja_subtitle_import_source_frame_rate_label(inputs)
	if (locale === "hi") return hi_subtitle_import_source_frame_rate_label(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_import_source_frame_rate_label(inputs)
	return en_subtitle_import_source_frame_rate_label(inputs)
});